import { Button, Typography, styled } from '@mui/material';
import MailLockIcon from '@mui/icons-material/MailLock';
import { MuiOtpInput } from 'mui-one-time-password-input';

const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  },

  OtpContainer: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
    alignItems: 'center',
    width: '100%',
    maxWidth: '25rem',
  },

  verifyButton: { p: 2, mt: '2rem' },
};

const OtpIcon = styled(MailLockIcon)(({ theme }) => ({
  color: theme.palette.primary.main,
  fontSize: 90,
  mb: '2rem',
}));

const OtpForm = ({ token, onChange, onClick }: any) => {
  return (
    <>
      <OtpIcon />

      <Typography sx={{ fontSize: '2.375rem' }}>OTP Verification</Typography>
      <Typography sx={{ fontSize: '1rem', mb: '2rem' }}>
        Check your company email for the One Time Password.
      </Typography>

      <MuiOtpInput
        sx={{ marginTop: '1rem' }}
        value={token}
        gap={1}
        length={6}
        onChange={onChange}
      />

      <Button
        fullWidth
        type='button'
        variant='contained'
        color='primary'
        disabled={token.length === 6 ? false : true}
        sx={styles.verifyButton}
        onClick={() => onClick()}
      >
        Verify
      </Button>
    </>
  );
};

export default OtpForm;
